import { useRecoilState } from "recoil";
import {
  childFirstNameState,
  childLastNameState,
  displayNameState,
} from "../../state/child-details";
import { useEffect } from "react";

function useCreateDisplayName(): string {
  const [firstName] = useRecoilState(childFirstNameState);
  const [lastName] = useRecoilState(childLastNameState);
  const [displayName, setDisplayName] = useRecoilState(displayNameState);

  useEffect(() => {
    const firstNameTrimmed = firstName.trim();
    const lastNameTrimmed = lastName.trim();

    if (!firstNameTrimmed || !lastNameTrimmed) {
      setDisplayName("");
    } else {
      const result = [] as string[];

      result.push(firstNameTrimmed);
      result.push(lastNameTrimmed[0]);

      const newDisplayName = result.join(" ").trim();

      if (newDisplayName !== displayName && newDisplayName) {
        setDisplayName(newDisplayName);
      }
    }
  }, [firstName, lastName, displayName, setDisplayName]);

  return displayName;
}

export default useCreateDisplayName;
